import React, { ChangeEvent, useEffect, useState } from "react";
//@ts-ignore
import logo from "../../../assets/logo-black.png";
import { Container } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { AuthAPI } from "../../../api/auth";
import { SessionStorage } from "../../../utils/storage";
import { TOKEN_KEY } from "../../../constants/appkeys";
import { autoDirect } from "../../../services/session_service/session_service";

interface FormDataType {
  email: string;
  password: string;
}
const initialFormData: FormDataType = {
  email: "",
  password: "",
};
const Auth = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState<FormDataType>(initialFormData);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const handleInputChange = (
    e: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target as HTMLInputElement;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    const checkRedirect = async () => {
      await autoDirect();
      setLoading(false);
    };

    checkRedirect();
  }, []);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const dataToSend = {
      email: formData.email,
      password: formData.password,
    };

    const res = await AuthAPI.login(dataToSend);
    if (res.token) {
      SessionStorage.set(TOKEN_KEY, res.token);
      navigate("/vips/mainpage");
    } else {
      setError(true);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Container fluid className="flex flex-col h-screen">
      <div className="grid place-items-center mx-2 my-20 sm:my-auto">
        <div
          className="w-11/12 p-12 sm:w-8/12 md:w-6/12 lg:w-5/12 2xl:w-4/12 
            px-6 py-10 sm:px-10 sm:py-6 
            bg-white rounded-lg shadow-md lg:shadow-lg"
        >
          <Link to="/" className="w-full flex justify-center items-center">
            <img alt="Casino24" src={logo} className="w-[10rem] " />
          </Link>

          <form className="mt-10" method="POST" onSubmit={handleSubmit}>
            <label
              htmlFor="email"
              className="block text-xs font-semibold text-gray-600 uppercase"
            >
              E-mail
            </label>
            <input
              id="email"
              type="email"
              name="email"
              onChange={handleInputChange}
              value={formData.email}
              placeholder="Enter Email"
              autoComplete="email"
              className="block w-full py-3 px-1
                    text-gray-800 appearance-none 
                    border-b-2 border-gray-100
                    focus:text-gray-500 focus:outline-none focus:border-gray-200"
              required
            />

            <label
              htmlFor="password"
              className="block mt-4 text-xs font-semibold text-gray-600 uppercase"
            >
              Password
            </label>
            <input
              id="password"
              type="password"
              name="password"
              onChange={handleInputChange}
              value={formData.password}
              placeholder="Enter Password"
              autoComplete="current-password"
              className="block w-full py-3 px-1 mb-4
                    text-gray-800 appearance-none 
                    border-b-2 border-gray-100
                    focus:text-gray-500 focus:outline-none focus:border-gray-200"
              required
            />

            {error && (
              <div className="sm:flex sm:flex-wrap text-sm text-center text-red-500">
                Invalid username or password!
              </div>
            )}

            <button
              type="submit"
              className="w-full py-3 mt-10 bg-gray-800 rounded-sm
                    font-medium text-white uppercase
                    focus:outline-none hover:bg-gray-700 hover:shadow-none"
            >
              Login
            </button>

            {/* <div className="sm:flex sm:flex-wrap mt-8 sm:mb-4 text-sm text-center">
              <a href="/" className="flex-2 underline">
                Forgot password?
              </a>
            </div> */}
          </form>
        </div>
      </div>
    </Container>
  );
};

export default Auth;
